import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { JwtHelperService } from '@auth0/angular-jwt';

@Injectable({
  providedIn: 'root'
})
export class OperadoresService {

  API_URI = 'https://vigiliner.com.mx:1829/api';
  search = "";

  constructor(private http: HttpClient, public jwtHelper: JwtHelperService) { }
  /**
   * Decodifica el token para obtener
   * el clienteID
  **/
  cliente() {
    const cliente = this.jwtHelper.decodeToken(localStorage.getItem('access_token'));
    return cliente.clienteID;
  }
  /**
   * Trae el listado de los operadores dependiendo del cliente
   * @param cliente es el clienteID se obtiene de cliente()
  **/
  listadoOperadores() {
    const cliente = this.cliente();
    return this.http.post<any[]>(`${this.API_URI}/listadoOperadores`, {cliente});
  }
  /**
   * Crear un nuevo operador
   * @param nombre Nombre(s) del operador
   * @param paterno Primer apellido
   * @param materno Segundo apellido
   * @param empleado Nuermos de empleado
   * @param licencia Numero de licencia
   * @param vigencia Fecha vence la licencia del operador
  **/
  nuevOperador(nombre: string, paterno: string, materno: string, empleado: any, licencia: string, vigencia: string) {
    const cliente = this.cliente();
    // tslint:disable-next-line:max-line-length
    return this.http.post<any[]>(`${this.API_URI}/nuevOperador/`, {nombre, paterno, materno, empleado, licencia, cliente, vigencia});
  }
  /**
   * Envia datos para actualizar datos del operador
   * @param uid Clave unica del operador
   * @param nombre Nombre(s) del operador
   * @param paterno Primer apellido
   * @param materno Segundo apellido
   * @param empleado Nuermos de empleado
   * @param licencia Numero de licencia
   * @param vigencia Fecha vence la licencia del operador
  **/
  actualizarOperador(nombre: string, paterno: string, materno: string, empleado: any, licencia: string, vigencia: string, uid: string) {
    // tslint:disable-next-line:max-line-length
    return this.http.post<any[]>(`${this.API_URI}/actualizarOperador/`, {nombre, paterno, materno, empleado, licencia, vigencia, uid});
  }
  /**
   * Eliminar al operador
   * @param uid Clave unica del operador
  **/
  eliminarOperador(uid: number) {
    return this.http.post<any>(`${this.API_URI}/eliminarOperador/`, {uid});
  }
  /**
   * Obtener el historial del operador
   * sus incidencias y unidades asignadas
   * @param uid Clave unica del operador
  **/
  historialOperadores(uid: string) {
    return this.http.get<any>(`${this.API_URI}/historialOperadores/${uid}`);
  }
  /**
   * Crear una incidencia para el operador
   * @param unidad Identificador de unidad
   * @param costo Monto total de incidencia
   * @param incidencia Descripcion de la incidencia
   * @param fecha Fecha que ocurrio la incidenca
   * @param operador Operador al que se levanta la incidencia
  **/
  nuevaIncidencia(unidad: number, costo: string, incidencia: string, fecha: string, operador: number) {
    return this.http.post<any[]>(`${this.API_URI}/nuevaIncidencia/`, {unidad, costo, incidencia, fecha, operador});
  }
  /**
   * Cambiar el estatus de la incidencia
   * @param uidInc Clave unica de incidencia
   * @param estatus Estatus de la incidencia
  **/
  edtarIncidencia(uidInc: number, estatus: string) {
    return this.http.post<any[]>(`${this.API_URI}/edtarIncidencia/`, {uidInc, estatus});
  }
  /**
   * Actualización de la unidad
   * @param unidad Identificador de unidad
   * @param operador Identificador de operador
   * @param geocerca Identificador de geiocerca
   * @param consumo Consumo estimado de gasolina
   * @param icono Como s emostrara la unidad
   * @param color Color que tendra la unidad
   * @param fechaServicio Fecha del siguiente servicio
   * @param kmservicio A los cuantos Km necesita servicio
   * @param periodo En cuanto tiempo se avisara de los servicios
  **/
 // tslint:disable-next-line:max-line-length
  actualizarUnidad(unidad: number, operador= null, geocerca= null, consumo= null, icono: string, color: string, fechaServicio= null, kmservicio= null, periodo= null, serie: string, modelo: string, marca: string, anio: string, placas: string) {
  // tslint:disable-next-line:max-line-length
  return this.http.post<any>(`${this.API_URI}/actualizarUnidad/`, {unidad, operador, geocerca, consumo, icono, color, fechaServicio, kmservicio, periodo, serie, modelo, marca, anio, placas});
  }
  /**
   * No muestra el historial por unidad
   * cuales operadores ha tenido y los sevicios que
   * se le han echo
   * @param uid Clave unica de la unidad
  **/
  historilUnidad(uidUnidad: string) {
    return this.http.get<any>(`${this.API_URI}/historilUnidad/${uidUnidad}`);
  }
  /**
   * Envian datos para crear un nuevo servicio
   * @param uid Clave unica de la unidad
   * @param fecha Fecha que se realizo el servicio
   * @param detalle Descripcion del servicio que se realizo
  **/
  nuevoServicio(uidUnidad: number, fecha: string, detalle: string) {
    return this.http.post<any[]>(`${this.API_URI}/nuevoServicio/`, {uidUnidad, fecha, detalle});
  }

}
